import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["intl", "features"];
import React from 'react';
import { injectIntl } from 'react-intl-next';
import { useClients } from '../../../confluence/clients';
import { ConfluenceFeaturesProvider } from '../../../confluence/confluence-features';
import { usePrimarySiteConfluenceAdvancedSearchUrlFactory } from '../../../confluence/confluence-utils/confluence-url-utils';
import { messages } from '../../../messages';
import { LegacyContextConverter } from '../../legacy-context-converter';
import { SearchDialogProduct } from '../../product-router';
import { EMPTY_SEARCH_ITEMS } from '../../product-router/product';
import { useSearchConfigContext } from '../../../common/search-config-provider';
import { ConfluenceAsyncWrapper } from './confluence-async-wrapper';
import { defaultPermissionsSupplier } from './permission-supplier';
export var ConfluenceTabWithIntl = function ConfluenceTabWithIntl(_ref) {
  var intl = _ref.intl,
    features = _ref.features,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useClients = useClients(),
    recentClient = _useClients.recentClient;
  var _useSearchConfigConte = useSearchConfigContext(),
    confluenceSites = _useSearchConfigConte.confluenceSites;
  var defaultRecentItemSupplier = function defaultRecentItemSupplier() {
    return Promise.all([recentClient.getRecentItems().promise(), recentClient.getRecentSpaces().promise()]).then(function (results) {
      return {
        size: results.reduce(function (sum, _ref2) {
          var items = _ref2.items;
          return sum + items.length;
        }, 0),
        sections: []
      };
    });
  };

  // Post query supplier not implemented in Confluence until it starts using the generic dialog components
  var defaultPostQueryItemSupplier = function defaultPostQueryItemSupplier() {
    return Promise.resolve(EMPTY_SEARCH_ITEMS);
  };
  var suppliers = {
    preQueryItemSupplier: rest.preQueryItemSupplier || defaultRecentItemSupplier,
    postQueryItemSupplier: rest.postQueryItemSupplier || defaultPostQueryItemSupplier
  };
  var confluenceAdvancedSearchUrlFactory = usePrimarySiteConfluenceAdvancedSearchUrlFactory();
  return /*#__PURE__*/React.createElement(LegacyContextConverter, null, /*#__PURE__*/React.createElement(ConfluenceFeaturesProvider, {
    features: features
  }, /*#__PURE__*/React.createElement(SearchDialogProduct, _extends({}, rest, {
    permissionSupplier: confluenceSites.length > 0 ? defaultPermissionsSupplier : rest.permissionSupplier,
    PLS_DONT_USE_skipDefaultStateManagement: true,
    id: "confluence",
    title: intl.formatMessage(messages.confluence_tab_label)
    // A note: These sections are not actually interpreted by the Confluence tab, but are put here for future use
    ,
    sections: [{
      id: 'confluence.page,blogpost,attachment',
      title: intl.formatMessage(messages.confluence_pages_blogs_attachments_section_heading)
    }, {
      id: 'confluence.space',
      title: intl.formatMessage(messages.confluence_spaces_section_heading)
    }, {
      id: 'urs.user-confluence',
      title: intl.formatMessage(messages.confluence_people_section_heading)
    }]
  }, suppliers, {
    generateAdvancedSearchUrl: confluenceAdvancedSearchUrlFactory,
    expandedStateInputPlaceholder: intl.formatMessage(messages.confluence_search_input_expanded_placeholder)
  }), /*#__PURE__*/React.createElement(ConfluenceAsyncWrapper, _extends({}, rest, {
    debounceTime: 250
  })))));
};

/**
 * The canonical implementation of a tab to show Confluence search results inside of the search dialog
 *
 * Can be imported across multiple Atlassian products and will show Confluence results there
 */
export var ConfluenceTab = injectIntl(ConfluenceTabWithIntl);